// File.type can be empty for Illustrator and images. Match the extensions explicitly allowed by the input,
// as well as MIME types; the server validates the uploaded blob's type and size.
export function acceptsAttachment(file, accept) {
  const types = accept.split(",").map(type => type.trim().toLowerCase()).filter(Boolean)
  const name = file.name.toLowerCase()
  const mime = file.type.toLowerCase()
  return types.length === 0 || types.some(type => type.startsWith(".") ? name.endsWith(type) : type === mime)
}
